module.exports = __webpack_public_path__ + "static/media/add-circle.7cc70d13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/add-circle.svg
// module id = 979
// module chunks = 0